module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "c-section c-section--game"
  }, [_c('div', {
    staticClass: "o-container o-container--small"
  }, [_c('main-header'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "c-answers",
    class: {
      'c-answers--complete': _vm.stage > 4
    }
  }, [_c('div', {
    staticClass: "c-answers__wrap"
  }, [_c('div', {
    staticClass: "c-answers__chest"
  }), _vm._v(" "), _c('div', {
    staticClass: "c-inari c-answers__inari",
    class: {
      'c-inari--active': _vm.stage <= 4
    }
  }, [_c('div', {
    staticClass: "c-answers__bubble",
    class: {
      'c-answers__bubble--animate': _vm.animateInari, 'c-answers__bubble--correct': _vm.recentlyCorrect, 'c-answers__bubble--incorrect': !_vm.recentlyCorrect
    }
  }, [(!_vm.recentlyCorrect) ? _c('div', [_vm._v("Try Again!")]) : _vm._e(), _vm._v(" "), (_vm.recentlyCorrect) ? _c('div', [_vm._v("SUGOI! "), _c('span', [_vm._v("(awesome!)")])]) : _vm._e()]), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.baseUrl + "img/inari.svg"),
      "alt": "INARI"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "c-answers__hint",
    class: {
      'c-answers__hint--active': !_vm.recentlyCorrect
    }
  }, [_vm._v(_vm._s(_vm.hints[_vm.stage]))]), _vm._v(" "), _c('form', {
    staticClass: "c-answer-form",
    on: {
      "click": _vm.gameOn
    }
  }, _vm._l((5), function(n, index) {
    return _c('div', {
      ref: "formItem",
      refInFor: true,
      staticClass: "c-answer-form__item",
      class: [_vm.answerStates[index], {
        'c-answer-form__item--active': _vm.stage === index && _vm.formActive
      }]
    }, [_c('div', {
      staticClass: "c-answer-form__icon"
    }), _vm._v(" "), _c('div', {
      staticClass: "c-anwer-form__answer"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.answers[index]),
        expression: "answers[index]"
      }],
      staticClass: "riddle-input",
      attrs: {
        "type": "text",
        "maxlength": "2",
        "placeholder": "?",
        "disabled": _vm.checkingAnswer || index < _vm.stage
      },
      domProps: {
        "value": (_vm.answers[index])
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.answers, index, $event.target.value)
        }, _vm.update],
        "focus": _vm.gameOn,
        "blur": _vm.gameOff
      }
    }), _vm._v(" "), _c('span', {
      class: {
        'c-answer--ready': _vm.answers[index] === ''
      }
    }, [_vm._v(_vm._s(_vm.answers[index] ? _vm.answers[index] : '?'))])])])
  }))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stage < 5),
      expression: "stage < 5"
    }],
    ref: "riddleSection",
    staticClass: "c-riddles",
    class: {
      'c-riddles--active': _vm.formActive
    }
  }, [_c('div', {
    staticClass: "c-scroll c-scroll--large"
  }, [_c('img', {
    staticClass: "c-scroll__top",
    attrs: {
      "src": (_vm.baseUrl + "img/scroll/top.svg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-scroll__middle"
  }, [_c('svg', {
    staticClass: "c-scroll__shadow c-scroll__shadow--top",
    attrs: {
      "width": "532.4",
      "height": "81.16",
      "preserveAspectRatio": "xMinYMin meet",
      "viewBox": "0 0 532.4 81.16",
      "role": "presentation"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#cfa973",
      "d": "M532.4 0v43.72L0 81.16V0z"
    }
  })]), _vm._v(" "), _c('div', {
    ref: "riddleContent",
    staticClass: "c-riddles__content"
  }, [_c('header', [_c('h3', [_vm._v("Scroll " + _vm._s(_vm.stage + 1))]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('ul', {
    staticClass: "c-riddles__list"
  }, _vm._l((_vm.riddles[_vm.stage]), function(riddle, index) {
    return _c('li', [_c('div', {
      staticClass: "c-riddles__icon"
    }, [_c('img', {
      attrs: {
        "src": (_vm.baseUrl + "img/riddles/" + (riddle.img)),
        "width": riddle.imgWidth,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "c-riddles__text s-entry-content"
    }, [_c('p', [_c('strong', [_vm._v("Riddle " + _vm._s(index + 1))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(riddle.text))])])])
  }))]), _vm._v(" "), _c('svg', {
    staticClass: "c-scroll__shadow c-scroll__shadow--bottom",
    attrs: {
      "width": "532.4",
      "height": "81.28",
      "preserveAspectRatio": "xMinYMax meet",
      "viewBox": "0 0 532.4 81.28",
      "role": "presentation"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#cfa973",
      "d": "M0 12.28L532.4 0v81.28H0z"
    }
  })])]), _vm._v(" "), _c('img', {
    staticClass: "c-scroll__bottom",
    attrs: {
      "src": (_vm.baseUrl + "img/scroll/bottom.svg"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('final-riddle', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.stage === 5),
      expression: "stage === 5"
    }]
  }), _vm._v(" "), (_vm.stage === 6) ? _c('entry-form') : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-instructions s-entry-content"
  }, [_c('h3', [_vm._v("How to play")]), _vm._v(" "), _c('p', [_vm._v("Clear your mind of all distractions. That means stop eating too! It’s time to solve some riddles.")]), _vm._v(" "), _c('p', [_vm._v("To unlock the secrets of ikigai, you must tell me the correct 5-letter passcode and answer a final question correctly. Each letter of the passcode contains a scroll with 3 riddles. Their answers all begin with the letter that you must enter above the scroll.")]), _vm._v(" "), _c('p', [_vm._v("If you make an incorrect attempt, I will provide a hint to help.")]), _vm._v(" "), _c('p', [_vm._v("Good luck!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("All answers begin with the letter you seek.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fed57b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Game.vue
// module id = 60
// module chunks = 0